import { useRequest } from 'ahooks';
import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';
import { COMBINEID_REG } from '@intelligence/utils/constant';
// company detail Companies people
export const usePeople = <T extends unknown>(params: T) => {
  if (!params?.company_id) return {};
  if (!COMBINEID_REG.test(params.company_id)) return {}; // 添加ID校验规则
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/intelligence_pc/detail/company/people',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'people',
    manual: false,
    loadingDelay: 0,
  });
  return {
    ...data,
  };
};
